import { BehaviorSubject, combineLatest, Observable, ReplaySubject, Subject, zip, of } from 'rxjs';
import { SearchCriteria } from '../../../ViewModules/shared-components/ui-search/ui-search.component';
import { CommonUtilty } from './../utilities/commonUtility';
import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { share, delay } from 'rxjs/operators'
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';

@Injectable()
export class ClientService {

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService,
        private commonUtilty: CommonUtilty
    ) { }

    // Fetch a single policy based on id

    searchClient(searchParams): Observable<any> {
        let me = this;
        let params = [];
        params.push(searchParams.criteriaFirstName);
        params.push(searchParams.criteriaLastName);
        params.push(searchParams.criteriaDOB);
        params.push(searchParams.criteriaGender);
        params.push(searchParams.criteriaCompanyName);
        params.push(searchParams.criteriaContactPerson);

        let clientDataSubject = new Subject<any>(); // Will use this subject to emit data that we want

        this.apiRequest.getCallWithAPIMapper('searchClient', null, null, params)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                console.log(returnObj);
                clientDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return clientDataSubject;
    }

    getClientById(id) {
        let me = this;
        let clientDataSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let pathVariables = [];
        pathVariables.push(id || null);
        this.apiRequest.getCallWithAPIMapper('fetchClientById', null, null, pathVariables)
        // this.apiRequest.getCallWithAPIMapper('fetchClientById' + id)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                clientDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return clientDataSubject;

    }
    saveClient(clientDO): Observable<any> {
        let self = this; //let policyIO = policyIO
        let clientDataSubject = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        this.apiRequest.post('client/save', clientDO)
            .subscribe(jsonResp => {
                clientDataSubject.next(jsonResp);

            }, errResp => {
                clientDataSubject.next(errResp);
            })
        return clientDataSubject;
    }

    clientDedup(clientDO): Observable<any> {
        let self = this; //let policyIO = policyIO
        let clientDataSubject = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        let DataList: any[] = [];
        this.apiRequest.post('client/clientDedup', clientDO)
            .subscribe(jsonResp => {

                if (Array.isArray(jsonResp)) {
                    jsonResp.forEach(element => {
                        DataList.push(element);
                    });
                }

                clientDataSubject.next(DataList);
                clientDataSubject.complete();

                // clientDataSubject.next(jsonResp);

            }, errResp => {
                clientDataSubject.next(errResp);
            })
        return clientDataSubject;
    }


    getprovinceAndCities(postalCode: number): Observable<any> {
        let me = this;
        let provinceAndCitiesArr = [];
        let provinceAndCities = new Subject<any>();
        let pathVariables = [];
        pathVariables.push(String(postalCode));
        this.apiRequest.getCallWithAPIMapper('fetchByPostCode', null, null, pathVariables )
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                provinceAndCitiesArr.push(jsonResp);
                console.log(provinceAndCitiesArr);
                provinceAndCities.next(provinceAndCitiesArr);
            });

        return provinceAndCities;
    }


    getClientByGuid(guid) {
        let me = this;


        let clientDataSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let pathVariables = [];
        pathVariables.push(guid);
        this.apiRequest.getCallWithAPIMapper('clientFetchByGuid', null, null, pathVariables)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                console.log(returnObj);
                clientDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return clientDataSubject;

    }

    getInsuredByPolicy(data, isOnlyBasedOnPolicy?) {
        let me = this;
        let clientDataSubject = new Subject<any>(); // Will use this subject to emit data that we want
        this.apiRequest.postCallWithAPIMapper('searchInsured', data)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                clientDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return clientDataSubject;

    }

    insuredByPolicySubjects: any = {}
    insuredByPolicyCache = {}
    getInsuredOnlyByPolicy(data, proposalNum?) {
        let me = this;

        if (this.insuredByPolicyCache[proposalNum]) {
            return of(this.insuredByPolicyCache[proposalNum]).pipe(delay(200));
        }

        else if (this.insuredByPolicySubjects[proposalNum]) {
            return this.insuredByPolicySubjects[proposalNum]
        }
        else {

            this.insuredByPolicySubjects[proposalNum] = new Subject<any>(); // Will use this subject to emit data that we want
            this.apiRequest.postCallWithAPIMapper('searchInsured', data)
                .pipe(share()).subscribe(jsonResp => {
                    let returnObj = jsonResp;
                    this.insuredByPolicySubjects[proposalNum].next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                    this.insuredByPolicyCache[proposalNum] = returnObj// incidentList is a Subject and emits an event thats being listened to by the components
                });
        }

        return this.insuredByPolicySubjects[proposalNum];
    }


    getListsOfInsuredByPolicyList(data) {
        let me = this;
        let insuredListSubject = new BehaviorSubject<any>([]); // Will use this subject to emit data that we want
        let observables = []
        var payload = {}
        payload["page"] = 0
        payload["size"] = 1000000
        payload["searchCriteriaList"] = []

        if (data) {
            data.forEach(element => {
                let searchCriteria = []
                var criteriaItem = {}
                criteriaItem["paramName"] = 'proposalNum' //verify
                criteriaItem["paramValue"] = element.proposalNum; //verify
                searchCriteria.push(criteriaItem)
                payload["searchCriteriaList"] = JSON.parse(JSON.stringify(searchCriteria))

                observables.push(this.getInsuredOnlyByPolicy(payload, element.proposalNum))
            });
        }
        zip(...observables)
            .subscribe(responses => { //list of insureds
                let returnObjects = responses;
                let insuredList = this.commonUtilty.extractInsuredsListOutOfSearchResults(responses);
                insuredListSubject.next(insuredList); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return insuredListSubject;

    }


}


